module.exports = __webpack_public_path__ + "static/Clearmind_Intro-ce80d64c3851c4b3d6100bba2ee818f3.gif";